export default {
  getDictList: '/api/dict/getDictList', // 查询字典
  editDict: '/api/dict/editDict', // 修改字典
  addDict: '/api/dict/addDict', // 添加字典
  //身份证识别
  recognitionIdCard: '/api/admin/recognitionIdCard',
  //项目列表-临时
  getProjectListM: '/api/migration/getProjectList',
  //发票列表-临时
  getInvoiceListM: '/api/migration/getInvoiceList',
  //批量导入
  importInvoiceTemp: '/api/invoice/importInvoiceTemp',
  //收付款流水
  getBankAccount: '/api/migration/getBankAccount',
  //完税凭证
  getDutyPaidProofListM: '/api/migration/getDutyPaidProofList',
  importDPPTemp: '/api/dutyPaidProof/importDPPTemp',
  //外经证
  getTaxCrossRegionalListM: '/api/migration/getTaxCrossRegionalList',
  importTCRTemp: '/api/financeTaxCrossRegional/importTCRTemp',
  //流水
  getBankAccountM: '/api/migration/getBankAccount', //查询账户
  getAccountBookM: '/api/migration/getAccountBook', //根据账户查询流水
  importFTTemp: '/api/financeTransactionLog/importFTTemp',
};
